<template>
  <div>
    <point-select :config="{ defaultValue: 'L1', must: true }" labelText="收费方式" v-model="chargeWay" :pList="chargeList" @visible-change="visChange"></point-select>
    <point-select :config="{ must: true }" labelText="广告类型" v-model="advertType" :pList="advTypes">
      <div slot="empty" class="my-sel-empty__data">暂未开通，请联系管理员</div>
    </point-select>

    <div v-if="isShowPkg" class="search_item must">
      <div class="label"><span>客户/用户</span></div>
      <div class="main">
        <custom-user ref="cuRef" @change="handleCUChange" />
      </div>
    </div>

    <el-popover v-if="isShowPkg" popper-class="form_pop el-select-dropdown pkg_popper" style="padding: 0; height: 330px" @show="popShow" @hide="isIconDown = true">
      <div slot="reference" class="pkg search_item must">
        <div class="label"><span>选择套餐</span></div>
        <div class="main pkg_list_main">
          <span v-if="!choosePkg || !pkgNum" class="none">请选择</span>
          <span v-else>
            <span class="num">{{ pkgNum }}</span>
            <span class="els">{{ choosePkg.packageName }}</span>
          </span>
        </div>
        <i :class="{ 'el-icon-arrow-down': true, up: !isIconDown }"></i>
      </div>
      <div class="pkg_popper_main">
        <div ref="scrollCtn" class="list_ctn">
          <div v-if="pkgList.length == 0" class="data-none" style="color: #ccc; font-size: 12px">无数据</div>
          <div ref="scrollList" class="list">
            <el-radio-group v-model="choosePkg" @change="pkgChange">
              <el-radio v-for="item in pkgList" :key="item.id" :label="item" :value="item">
                <span class="els fl" :title="item.packageName">{{ item.packageName }}</span>
                <div v-if="choosePkg && choosePkg.id === item.id" class="fr">
                  <el-input v-model="pkgNum" size="mini" @keyup.native="e => { numChange(e, item) }"></el-input>
                  <span>/</span>
                  <span class="total">{{ item.packageInfoNum || 0 }}</span>
                </div>
              </el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import CustomUser from '@/views/PutOrder/components/OrderForm/CustomUser'
import PointSelect from '@/views/PutOrder/components/OrderForm/Select'
import { ChargeWayEnum } from '@/views/PutOrder/config.js'

const putMode2AdType = new Map([
  ['L1', [1, 3, 4, 5,12, 12]],
  ['L2', [2, 3, 4, 5,12,12]],
  ['L3', [2, 3, 4, 5,12,12]],
  ['L4', [7]]
])

export default {
  name: 'PutScheme',
  components: { PointSelect, CustomUser },
  data() {
    return {
      chargeWay: [],
      advTypes: [], // 广告类型(需与投放方案联动)
      advertType: [],
      pkgList: [],
      isShowPkg: false,
      isIconDown: true,
      choosePkg: null,
      pkgNum: '',
      pkgContracts: []
    }
  },
  computed: {
    chargeList() {
      const { CHARGE_TYPE } = this.$store.state.label.sortMap
      return CHARGE_TYPE || []
    },
    originTypes() {
      return this.$store.state.common.advertTypes
    }
  },
  watch: {
    async chargeWay(v) {
      if (v && v[0]) {
        console.log(v)
        let payWay = ChargeWayEnum[v[0]] || 'cpd'
        this.chargeWayChange(payWay)
        this.$emit('change', 'putscheme', v)

        /**
         * 收费方式与广告类型的对应关系
         * CPD(L1)       => CPD收费(1)、定制商业(3)、普通公益(4)、定制公益(5)
         * CPR按天(L2)   => CPR收费(2)、定制商业(3)、普通公益(4)、定制公益(5)
         * CPR按流量(L3) => CPR收费(2)、定制商业(3)、普通公益(4)、定制公益(5)
         * 套餐兑换(L4)  => 流量套餐(7)
         * 限量广告      => RTB(限量)(11)、定制商业(3)、普通公益(4)、定制公益(5)
         * 实时广告      => CPR收费(2)、定制商业(3)、普通公益(4)、定制公益(5)
         * 网络广告（手机上的，不加广告类型）
         */
        // 根据选定投放方案确定广告类型
        if (!this.originTypes || !this.originTypes.length) await this.$store.dispatch('getAdvertType')
        const typeCodes = putMode2AdType.get(v[0])
        const filt = this.originTypes.filter(e => typeCodes.indexOf(e.value) > -1)
        this.advTypes = filt.map(e => {
          e.code = e.value
          e.name = e.label
          return e
        })
        // 若之前有选择广告类型,且在切换投放方案后不可选，则重置为可选广告类型中的第一项
        if (this.advertType[0] && this.advTypes.every(e => e.value !== this.advertType[0]) && this.advTypes[0]) {
          this.advertType = [ this.advTypes[0].value ]
        } else {
          this.advertType = []
        }
      } else {
        this.$emit('change', 'putscheme', [])
      }
      this.pkgContracts = []
    },
    advertType(v) {
      if (v && v[0]) {
        this.$emit('change', 'adtype', v)
      } else {
        this.$emit('change', 'adtype', [])
      }
    },
    pkgNum(v) {
      this.$emit('change', 'pkg', {
        data: this.choosePkg,
        num: v
      })
    },
    pkgContracts(v) {
      this.$store.commit('order/setData', { key: 'pkgContracts', value: v })
    }
  },
  methods: {
    visChange(flag) {
      if (flag) {
        // 列表展示的时候 隐藏所属城市的弹窗
        let cityPopper = document.querySelector('.gg-dist.el-popover')
        if (cityPopper && cityPopper.style.display != 'none') {
          cityPopper.style.display = 'none'
        }
      }
    },
    numChange(e, item) {
      let data = e.target.value
      let res = data === '' || isNaN(data) || data.indexOf('e') > -1 ? '' : data - 0
      if (res) {
        if (res > item.packageInfoNum) res = item.packageInfoNum
        if (res > 20) {
          res = 20
          this.messageTip('套餐码最多选择20个', 2)
        }
      }
      this.pkgNum = res
      this.pkgContracts = this.handleContracts()
    },
    handleContracts(v) {
      let list = this.choosePkg.packageContractRelations || []
      let arr = [],
        i = 0
      console.log(this.choosePkg)
      while (i < this.pkgNum && list[i]) {
        let contracts = list[i].contractCodes || []
        contracts.forEach((el) => {
          if (arr.indexOf(el) === -1) arr.push(el)
        })
        i++
      }
      return arr
    },
    handleCUChange(data, type) {
      if (type === 'pkg') {
        // 传递过来用户可使用套餐码数据
        this.pkgList = data
        this.pkgChange()
      } else if (type === 'user') {
        // 传递过来用户数据 带有客户id
        this.$emit('change', 'user', data)
      }
    },
    pkgChange(v) {
      this.pkgNum = ''
      this.choosePkg = null
      this.$nextTick(() => {
        this.choosePkg = v
      })
    },
    initOrReset() {
      let { code } = this.chargeList[0] || {}
      this.chargeWay = [code || ''] // 需要数组格式数据包装一个数据
      this.advertType = []

      this.$refs.cuRef && this.$refs.cuRef.init() // 客户用户数据重置
    },
    handleCthHeight() {
      this.$nextTick(() => {
        document.querySelector('.pkg').style.height = document.querySelector('.pkg .el-select__tags').clientHeight + 10 + 'px'
      })
    },
    async popShow() {
      this.isIconDown = false
    },
    resetPkg() {
      this.isShowPkg = false
      this.pkgList = []
    },
    chargeWayChange(data) {
      if (data != 'pkg') {
        this.resetPkg()
      } else {
        this.isShowPkg = true
      }
    }
  }
}
</script>

<style lang="sass">
.form_pop.pkg_popper
  padding: 10px
  width: 320px
</style>

<style lang="sass" scoped>
.search_item
  border: 1px solid #E9E9E9
  border-radius: 4px
  height: 40px
  margin-bottom: 20px
  &.must
    .label
      span:before
        content: '*'
        color: red
        position: absolute
        left: -6px
        top: 1px
  .label
    width: 87px
    text-align: right
    padding-right: 10px
    border-right: 1px solid #E9E9E9
    height: 20px
    line-height: 20px
    float: left
    margin-top: 10px
    font-weight: 600
    span
      position: relative
  .main
    padding-top: 5px
    line-height: 28px
    .none
      color: #999

.form
  ::v-deep .el-form
    .el-form-item
      margin-bottom: 20px
      border: 1px solid #E9E9E9
      border-radius: 4px
      padding: 5px 0 5px 19px

      .el-form-item__label
        color: #282729
        font-weight: 600
        border-right: 1px solid #e9e9e9
        padding: 0
        margin: 5px 0 0
        line-height: 20px
        width: 68px
        text-align: left

    .el-input
      width: 220px
      font-size: 12px
      input
        border: none
        padding-right: 0
        padding-left: 10px
        &:focus
          border-bottom: none !important
      .el-input__prefix
        display: none

.pkg
  position: relative
  width: 320px
  min-height: 40px
  margin-bottom: 20px
  border: 1px solid #E9E9E9
  border-radius: 4px

  .pkg_list_main
    cursor: pointer
    > span
      margin-left: 10px
    .num
      display: inline-block
      width: 40px
      height: 20px
      line-height: 20px
      text-align: center
      background: #ff3973
      color: #fff
      border-radius: 20px
      margin-right: 5px
    .els
      display: inline-block
      vertical-align: middle
      width: 140px

  .el-icon-arrow-down
    position: absolute
    right: 10px
    top: 50%
    margin-top: -5px
    color: #c0c4cc
    &.up
      transform: rotate(180deg)
      transition: all 0.2s

.el-select__tags
  padding-left: 95px
  width: 290px
  .el-tag--info.el-tag--mini
    background-color: #f0f2f5
    border-color: transparent
    margin: 2px 2px 2px 0
  .el-tag__close.el-icon-close
    background-color: #c0c4cc
    top: -7px
    color: #fff
  .el-select__tags-text
    display: inline-block
    overflow: hidden
    text-overflow: ellipsis

.pkg_popper_main
  .list_ctn
    height: 200px
    overflow: auto
  .list
    text-align: left
    line-height: 30px
    span
      cursor: pointer
    ::v-deep .el-radio-group
      width: 100%
      .el-radio
        display: block
        height: 40px
        padding: 10px
        line-height: 20px
        margin-right: 0
        &.is-checked
          background: #F5F5F5
        .el-radio__input
          float: left
          position: relative
          top: 3px
          margin-right: 10px
          &.is-checked
            &+.el-radio__label
              color: #282729
            .el-radio__inner
              border-color: #FF3973
              background: #FF3973
        .el-input
          width: 40px
          margin-right: 5px
          input
            height: 20px
            line-height: 20px
            padding: 0
            text-align: center

        .el-radio__label
          overflow: hidden
          .els
            display: inline-block
            width: 150px
          .total
            margin-left: 5px
</style>
